import Axios from "../helper/appConfig";

// Fetch payment history for a member
export const paymentService = (id) => {
  let data = {
    search: [
      {
        searchfield: "status",
        searchvalue: "Paid",
        criteria: "eq",
        datatype: "text",
      },
      {
        searchfield: "memberid",
        searchvalue: id,
        criteria: "eq",
        datatype: "ObjectId",
      },
    ],
    formname: "mypayment",
    sort: {
      scheduledate: 1,
    },
  };
  return Axios.post(`api/payments/filter`, data);
};

// Fetch outstanding payment schedules
export const paymentSchedulingService = (userId) => {
  return Axios.get(`api/paymentschedules/outstanding/${userId}`);
};

// Fetch outstanding payment schedules
export const paymentSchedulingDataService = (id) => {
  let body = {
    search: [
      {
        searchfield: "_id",
        searchvalue:id ,
        criteria: "eq",
        datatype: "ObjectId",
      },
    ],
    select: [
      {
        fieldname: "amount",
        value: 1,
      },
      {
        fieldname: "taxamount",
        value: 1,
      },
    ],
    formname: "mypaymentdue",
  };
  return Axios.post(`api/paymentschedules/filter`,body);
};

// Fetch member details
export const getMemberDataService = (id) => {
  let postData = {
    search: [
      { searchfield: "status", searchvalue: "active", criteria: "eq" },
      { searchfield: "_id", searchvalue: id, criteria: "eq" },
    ],
    select: [
      { fieldname: "fullname", value: 1 },
      { fieldname: "membernumber", value: 1 },
    ],
  };
  return Axios.post(`api/common/contacts/filter`, postData);
};

// Create a checkout session for payment
export const createCheckoutSessionService = (postData) => {
  return Axios.post(
    `api/integrations/webhooks/createcheckoutsession`,
    postData
  );
};

export const createCheckoutBillSessionService = (postData) => {
  return Axios.post(
    `api/integrations/webhooks/createbillcheckoutsession`,
    postData
  );
};
